import { CustomCard } from './CustomCard/CustomCard';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const TotalOcurrences = () => {
    const { chartData } = useServicesChartsDataContext();

    const totalOcurrences = chartData?.totalOcurrences || 0;

    return (
        <CustomCard title="Total de Ocorrências" value={totalOcurrences} single />
    );
};
